const routes = [
    {
        path: "/certificate/person",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "certificateperson_index"
        }
    },

];

export default routes;
